
import React from 'react';
import SEO from '@/components/common/SEO';
import Hero from '@/components/home/Hero';
import HowItWorks from '@/components/home/HowItWorks';
import Benefits from '@/components/home/Benefits';
import Testimonials from '@/components/home/Testimonials';
import CTA from '@/components/home/CTA';
import FeaturedPsychologistsCarousel from '@/components/home/FeaturedPsychologistsCarousel';

const Index = () => {
  return (
    <>
      <SEO 
        title="PsyOnline - Cuidar da saúde mental nunca foi tão acessível"
        description="Consultas online com profissionais qualificados, na comodidade da sua casa. Agende sua consulta psicológica com segurança e praticidade."
        keywords="psicologia online, terapia online, consulta psicológica, psicólogo online, saúde mental, atendimento psicológico"
        url="/"
      />
      
      <div className="space-y-16">
        {/* Hero Section */}
        <Hero />

        {/* Featured Psychologists Carousel */}
        <FeaturedPsychologistsCarousel />

        {/* How it works */}
        <HowItWorks />

        {/* Benefits */}
        <Benefits />

        {/* Testimonials */}
        <Testimonials />

        {/* CTA */}
        <CTA />
      </div>
    </>
  );
};

export default Index;
